import { FC, useState, Fragment } from "react";
import { ProjectDetailType } from "../types";
import { IconChevronDown } from "@tabler/icons-react";
import { Collapse, Fade } from "@mui/material";
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';

import ProgressBar from "./ProgressBar";
import Button from "../../../../../../components/form/Button";

interface ProjectDetailProps {
    detailProject: ProjectDetailType;
}

const Detail: FC<ProjectDetailProps> = ({ detailProject }) => {
    const [collapse, setCollapse] = useState(true);
    const theme = useTheme();
    const isMdUp = useMediaQuery(theme.breakpoints.up('md')); // true si >= md

    return (
        <div className="px-4 py-4 rounded-lg mb-4 bg-white relative">
            <div className="absolute top-2 lg:top-5 right-2 lg:right-4 z-10">
                <Button
                    onClick={() => setCollapse(!collapse)}
                    variant="transparent"
                >
                    <IconChevronDown className={`size-6 ${!collapse ? "rotate-0" : "-rotate-180"} transition-transform`} />
                </Button>
            </div>
            <Collapse in={!collapse} collapsedSize={isMdUp ? 40 : 100}>
                <div className="w-full flex flex-wrap items-start">
                    <Fade in={!collapse} unmountOnExit>
                        <div className="w-full lg:w-1/4">
                            <p className="text-base lg:text-lg text-normal text-[#757575] pb-1.5 lg:pb-1">Detalle del proyecto</p>
                            <img
                                className=" object-cover object-center h-[200px] w-full rounded-lg"
                                src={detailProject?.cover}
                                alt=""
                            />
                        </div>
                    </Fade>
                    <div className="w-full lg:w-3/4 md:px-4">
                        <Fade in={!collapse} unmountOnExit>
                            <div className="mt-4 lg:mt-0">
                                <p className="text-base lg:text-lg text-normal text-[#757575]">#{detailProject?.code}</p>
                                <div className="w-full text-blackGrayScale text-2xl lg:text-3xl font-semibold text-left tracking-wide">
                                    {detailProject?.name}
                                </div>
                                <p className="text-[#757575] text-base md:text-lg">
                                    {detailProject?.address}
                                </p>
                            </div>
                        </Fade>
                        <div className={`${!collapse ? "mt-4 gap-4" : "pr-6 gap-4 lg:gap-6 xl:gap-10"} flex flex-wrap`}>
                            <div>
                                <p className="text-sm font-bold">Valor de proyecto</p>
                                <p className="text-xs text-left text-[#757575]">
                                    {detailProject?.total_project_price}
                                </p>
                            </div>
                            <div>
                                <p className="text-sm font-bold">Unidades totales</p>
                                <p className="text-xs text-left text-[#757575]">
                                    {detailProject?.total_units}
                                </p>
                            </div>
                            <div>
                                <p className="text-sm font-bold">
                                    Fecha estimada de entrega
                                </p>
                                <p className="text-xs text-left text-[#757575]">
                                    {detailProject?.estimate_built_at}
                                </p>
                            </div>
                            <div>
                                <p className="text-sm font-bold">Disponible</p>
                                <p className="text-xs text-left text-[#757575]">
                                    {detailProject?.total_available_units}
                                </p>
                            </div>
                        </div>
                        <Fade in={!collapse} unmountOnExit>
                            <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
                                <div className="w-full flex flex-wrap mt-4">
                                    <div className="w-1/2">
                                        <p className="text-sm text-[#757575]">
                                            Unidades vendidas
                                        </p>
                                        <p className="text-base lg:text-lg font-bold text-[#212121]">
                                            {detailProject?.total_sold_units}
                                        </p>
                                    </div>
                                    <div className="w-1/2 flex flex-col items-end">
                                        <p className="text-sm text-[#757575]">
                                            Unidades disponibles
                                        </p>
                                        <p className="text-base lg:text-lg font-bold text-[#212121]">
                                            {detailProject?.total_available_units}
                                        </p>
                                    </div>
                                    <div className="w-full my-3">
                                        <ProgressBar
                                            percentage={detailProject?.units_percentage?.toFixed()}
                                        />
                                    </div>
                                </div>
                                <div className="w-full flex flex-wrap mt-4 px-4">
                                    <div className="w-1/2">
                                        <p className="text-sm text-[#757575]">
                                            Valor vendidas
                                        </p>
                                        <p className="text-base lg:text-lg font-bold text-[#212121]">
                                            {detailProject?.total_project_sold_price}
                                        </p>
                                    </div>
                                    <div className="w-1/2 flex flex-col items-end">
                                        <p className="text-sm text-[#757575]">
                                            Valor de proyecto
                                        </p>
                                        <p className="text-base lg:text-lg font-bold text-[#212121]">
                                            {detailProject?.total_project_price}
                                        </p>
                                    </div>
                                    <div className="w-full my-3">
                                        <ProgressBar
                                            percentage={detailProject?.price_percentage?.toFixed()}
                                        />
                                    </div>
                                </div>
                            </div>
                        </Fade>
                    </div>
                </div>
            </Collapse>
        </div >
    )
};

export default Detail;